import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';

export type Barcode = {
  bcid?: string;
  text: string;
  scale?: number;
  height?: number;
  includetext?: boolean;
  textalign?: string;
};

export type QRcode = {
  text: string;
  type?: string;
};

const $http = new APIManager();

const Api = {
  /**
   * [POST] QR URL
   * --
   */
  createQRUrl: async (body: QRcode) => {
    try {
      const res = await $http.post(APIConstant.CREATE_QR_URL, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] QR String
   * --
   */
  createQRString: async (body: QRcode) => {
    try {
      const res = await $http.post(APIConstant.CREATE_QR_STRING, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] QR Buffer
   * --
   */
  createQRBuffer: async (body: QRcode) => {
    try {
      const res = await $http.post(APIConstant.CREATE_QR_BUFFER, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Barcode URL
   * --
   */
  createBarcodeUrl: async (body: Barcode) => {
    try {
      const res = await $http.post(APIConstant.CREATE_BARCODE_URL, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Barcode Buffer
   * --
   */
  createBarcodeBuffer: async (body: Barcode) => {
    try {
      const res = await $http.post(APIConstant.CREATE_BARCODE_BUFFER, body);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
